<template>
  <div class="mt-2 mb-2 w-full justify-start text-left relative min-h-96">
    <ContentTimelineModal :phase="phase" @hide="hideModal" />

    <ol v-if="event == null" class="relative border-l border-gray-500  justify-start text-left">
      <li v-for="event in events" :key="event.id" class="w-full flex">
        <div class="w-full ml-6">
          <span class="absolute flex items-center justify-center w-6 h-6 bg-blue-200 rounded-full -left-3 ring-2 ring-blue-500  ">
            <svg aria-hidden="true" class="w-3 h-3 text-blue-800 " fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
          <h3 class="flex justify-start text-left items-center mb-1 text-lg font-semibold text-gray-900 ">
            {{ event.title && event.title[lg] }}

            <span v-if="event.warning != undefined" class="text-orange-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded   ml-3">
              <i class="fa-solid fa-triangle-exclamation mr-1" />
              {{ event.warning[lg] }}
            </span>

            <span v-if="event.danger != undefined" class="bg-red-100 text-red-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded   ml-3">{{ event.danger }}</span>
          </h3>
          <time class="justify-start text-left block mb-2 text-sm font-normal leading-none text-gray-400 "  :datetime="toISO(event.date)">
           {{ formatDate(event.date) }}
          </time>

          <p class="mb-4 text-base font-normal text-gray-600 " v-html="event.description[lg]" />

          <ul v-if="event?.substeps != null" class="mb-4 text-sm text-gray-600 ml-4">
            <li v-for="substep in event?.substeps" :key="substep.id">
              <div class="flex items-center justify-start">
                <i class="fa-solid fa-circle-check text-green-500 mr-2" />
                <span class="px-1">{{ substep.label[lg] }}</span>
                <span class="px-1">:</span>
                <img v-if="substep.image_id != null" :src="'https://files.b4food.io/b4food/images/' + substep.image_id + '?icon=true'" class="w-6 h-6 rounded-full mr-1" alt="image" />
                <span class="font-semibold">{{ substep.value }} {{ substep.unit }}</span>
              </div>
            </li>
          </ul>

          <div
            v-if="event.action != null && config?.button_label != null"
            class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-200 focus:text-blue-700      "
            @click="showModal(event.action)"
          >
            <i class="fa-solid fa-circle-info mr-2" />
            {{ config?.button_label[lg] }}
          </div>

          <div
            v-if="event.link != null && config?.button_label != null"
            class="cursor-pointer items-center px-4 py-1 text-xs font-medium text-gray-900 hover:text-blue-700 focus:z-10 focus:ring-4 focus:outline-none focus:ring-gray-200 focus:text-blue-700      "
            @click="openNewTab(event.link)"
          >
            {{ config?.button_label[lg] }}
            <i class="fa-solid fa-solid fa-up-right-from-square ml-2" />
          </div>
          <div class="mb-10" />
        </div>
        <div class="hidden w-4/12 bg-gray-400 w-96" />
      </li>
    </ol>
  </div>
</template>
<script>
import { Modal } from "flowbite";

import ContentTimelineModal from "@/components/content/lib/ContentTimelineModal.vue";
export default {
  name: "TimelineComponent",
  components: { ContentTimelineModal },
  props: {
    id: String,
    label: String,
    record: Object,
    required: Boolean,
    value: String,
    config: Object,
  },
  data() {
    return {
      output: "",
      events: [],
      lg: "FR",
      modal: null,
      phase: "shipment",
      result: [
        /*    {
                id: "111",
                date: "13 Mars 2023",
                title: {
                  "EN": "Shipment",
                  "FR": "Expéditon"
                },
                description: {
                  "EN": "Shipment",
                  "FR": "L'article a été prélévé le 13 Mars 2023 par GMT avec le numéro de suivi BE021342. La température de la palette été controlée conforme ainsi que celle du Camion. L'agent n'a pas constaté de problème de propreté dans le camion."
                },
                status: "OK",
                warning: {
                  "EN": "Missing documents",
                  "FR": "Documents de transport manquant"
                },
                step: "shipment",
                link: ""
              },
              {
                id: "112",
                date: "11 Mars 2023",
                title: {
                  "EN": "Packing",
                  "FR": "Emballage"
                },
                description: {
                  "EN": "Packing Packing Packing Packing Packing Packing",
                  "FR": "L'emballage a été effectué sans problème de conformité. Pas d'objet intrus détecté"
                },
                status: "OK",
                warning: null,
                step: "packing",
                link: ""
              },
              {
                id: "113",
                date: "14 février 2023",
                title: {
                  "EN": "Packing",
                  "FR": "Affinage"
                },
                description: {
                  "EN": "Packing Packing Packing Packing Packing Packing",
                  "FR": "Les contôles de température, pH ont été effectués et pas de non conformité détecté."
                },
                status: "OK",
                warning: null,
                step: "refining",
                link: ""
              },
              {
                id: "114",
                date: "14 février 2023",
                title: {
                  "EN": "Salting",
                  "FR": "Salage"
                },
                description: {
                  "EN": "Packing Packing Packing Packing Packing Packing",
                  "FR": "Salage dans bain de saumur dans sel avec numèro de lot 23232424."
                },
                status: "OK",
                warning: null,
                step: "salting",
                link: ""
              },*/
        /*
        {
          id: "115",
          date: "24 Décembre 2023",
          title: {
            EN: "Lot : S-24-359-04a",
            FR: "Lot : S-24-359-04a",
          },
          description: {
            EN: null,
            FR: null,
          },
          substeps: [
            {
              label: {
                EN: "Conformité Vétérinaire",
                FR: "Conformité Vétérinaire",
              },
              value: "Saisie Totale",
            },
            {
              label: {
                EN: "Motif",
                FR: "Motif",
              },
              value: "Balle de panse avérée",
            },
          ],
          status: "OK",
          warning: null,
          step: "inbound",
          link: "/admin/views/wild-game-batches/676a88ca78029686b58846d9",
        },
        {
          id: "118",
          date: "24 Décembre 2023",
          title: {
            EN: "Lot : S-24-355-11",
            FR: "Lot : S-24-355-11",
          },
          description: {
            EN: null,
            FR: null,
          },
          substeps: [
            {
              label: {
                EN: "Conformité Vétérinaire",
                FR: "Conformité Vétérinaire",
              },
              value: "Saisie Totale",
            },
            {
              label: {
                EN: "Motif",
                FR: "Motif",
              },
              value: "Balle de panse avérée",
            },
          ],
          status: "OK",
          warning: null,
          step: "inbound",
          link: "/admin/views/wild-game-batches/676a892d78029686b58846dc",
        },
        {
          id: "110",
          date: "24 Décembre 2023",
          title: {
            EN: "Ecorchage",
            FR: "Ecorchage",
          },
          description: {
            EN: null,
            FR: null,
          },
          substeps: [
            {
              label: {
                EN: "Conformité",
                FR: "Conformité",
              },
              value: "Conforme",
            },
          ],
          status: "OK",
          warning: null,
          step: "inbound",
          link: null,
        },
        {
          id: "119",
          date: "19 Décembre 2024",
          title: {
            EN: "Bon d'arrivage : BA-S-24354-01",
            FR: "Bon d'arrivage : BA-S-24354-01",
          },
          description: {
            EN: null,
            FR: null,
          },

          substeps: [
            {
              label: {
                EN: "Réceptioné par",
                FR: "Réceptioné par",
              },
              value: "BOURGUEIL Matthieu",
              unit: "",
              image_id: "65fbf60b555bb6bf38f92bc9",
            },

            {
              label: {
                EN: "Conformité",
                FR: "Conformité",
              },
              value: "Conforme",
              unit: "",
            },

            {
              label: {
                EN: "Poids Brut",
                FR: "Poids Brut",
              },
              value: "68",
              unit: "kg",
            },

            {
              label: {
                EN: "Température",
                FR: "Température",
              },
              value: "5",
              unit: "°C",
            },
          ],
          step: "inbound",
          status: "OK",
          warning: null,
          link: "/admin/views/private-inbound-hunting-items-2/67643ce54eaf5a6f39b88882",
        },*/
      ],
    };
  },
  watch: {
    value: function (val) {
      this.output = val;
    },
    record: function () {
      //this.events = this.result
      this.events = this.record?.steps;
    },
  },
  mounted() {
    this.output = this.value;

    //this.events = this.result;
    this.events = this.record?.steps;
    const $targetEl = document.getElementById("large-modal-pv");
    /*   const options = {
             placement: 'bottom-right',
             backdrop: 'dynamic',
             backdropClasses: 'bg-gray-900 bg-opacity-50  fixed inset-0 z-40',
             closable: true
         }*/
    this.modal = new Modal($targetEl);
    //    data-modal-target="large-modal-pv"
    //        data-modal-toggle="large-modal-pv"
  },
  methods: {
    openNewTab(url) {
      window.open(url, "_blank");
    },

    toISO(d) {
      const date = d instanceof Date ? d : new Date(d);
      return date.toISOString();
    },
    formatDate(d) {
      const date = d instanceof Date ? d : new Date(d);
      return new Intl.DateTimeFormat("fr-FR", {
        year: "numeric",
        month: "long",
        day: "2-digit",
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
      }).format(date);
    },

    formatDateOld(val) {
      if (val == undefined) return "";
      if (val == "") return "";

      let date = val.split("T");
      if (date.length != 2) {
        date = val.split(" ");
      }

      let d = date[0].split("-");

      return d[2] + "/" + d[1] + "/" + d[0] + " " + date[1];
    },
    hideModal(phase) {
      this.phase = phase;
      this.modal.toggle();
    },
    showModal(phase) {
      this.phase = phase;
      this.phase = "inbound";
      this.modal.toggle();
    },
    getData() {
      return this.output;
    },
  },
};
</script>
